import React from 'react';
import { useTranslation } from 'react-i18next';
import { Roadside, DriverCloud, FindShop, Legal, EcoPerk } from '/src/images/spark-driver';

const PERKS = [{
	icon: Roadside,
	labelKey: 'roadside',
}, {
	icon: Legal,
	labelKey: 'legal-assistance',
}, {
	icon: DriverCloud,
	labelKey: 'claims',
}, {
	icon: EcoPerk,
	labelKey: 'eco-perk',
}, {
	icon: FindShop,
	labelKey: 'find-repair-shops',
}];

const ShareAndExport = () => {
	const { t } = useTranslation(null, { keyPrefix: 'home-page.aaos' });

	return (
		<section id="aaos">
			<div>
				<h3>{t('all-from')}</h3>

				<div className="perk-container">
					{PERKS.map(({ icon, labelKey }, idx) => (
						<div key={`perk-${idx}`} className="list-item">
							<img className="icons" src={icon} alt={t(labelKey)} />
							<p>{t(labelKey)}</p>
						</div>
					))}
				</div>
			</div>
		</section>
	);
};

export default ShareAndExport;
